import { useLoggedInUser } from '../../modules/users/LoggedInUserProvider';
import { Permission } from '../../domain/permissions';

export const usePermissions = () => {
    const { loggedInUser } = useLoggedInUser();

    const hasPermission = (permission: Permission) => {
        return loggedInUser?.permissions?.includes(permission) || false;
    };

    const hasAnyPermission = (permissions: Permission[]) => {
        return permissions.some(permission => hasPermission(permission));
    };

    const hasAllPermissions = (permissions: Permission[]) => {
        return permissions.every(permission => hasPermission(permission));
    };

    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        permissions: loggedInUser?.permissions || [],
    };
};
